import { render, staticRenderFns } from "./ApiButton.vue?vue&type=template&id=321693cc&scoped=true"
import script from "./ApiButton.vue?vue&type=script&lang=ts"
export * from "./ApiButton.vue?vue&type=script&lang=ts"
import style0 from "./ApiButton.vue?vue&type=style&index=0&id=321693cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321693cc",
  null
  
)

export default component.exports